import { defineComponent as i, openBlock as o, createElementBlock as e, mergeProps as u, unref as l, renderSlot as g, createElementVNode as n, createCommentVNode as m } from "vue";
import { useScalarIcon as L } from "../hooks/useScalarIcon.js";
const V = { key: 0 }, f = { key: 1 }, H = { key: 2 }, h = { key: 3 }, A = { key: 4 }, k = { key: 5 }, w = {
  name: "ScalarIconArrowUpLeft"
}, y = /* @__PURE__ */ i({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: a } = L(s);
    return (p, t) => (o(), e("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, l(d)), [
      g(p.$slots, "default"),
      l(a) === "bold" ? (o(), e("g", V, t[0] || (t[0] = [
        n("path", { d: "M200.49,200.49a12,12,0,0,1-17,0L76,93v75a12,12,0,0,1-24,0V64A12,12,0,0,1,64,52H168a12,12,0,0,1,0,24H93L200.49,183.51A12,12,0,0,1,200.49,200.49Z" }, null, -1)
      ]))) : l(a) === "duotone" ? (o(), e("g", f, t[1] || (t[1] = [
        n("path", {
          d: "M168,64,64,168V64Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M197.66,186.34,127.31,116l46.35-46.34A8,8,0,0,0,168,56H64a8,8,0,0,0-8,8V168a8,8,0,0,0,13.66,5.66L116,127.31l70.34,70.35a8,8,0,0,0,11.32-11.32ZM72,72h76.69l-38.34,38.34h0L72,148.69Z" }, null, -1)
      ]))) : l(a) === "fill" ? (o(), e("g", H, t[2] || (t[2] = [
        n("path", { d: "M197.66,197.66a8,8,0,0,1-11.32,0L116,127.31,69.66,173.66A8,8,0,0,1,56,168V64a8,8,0,0,1,8-8H168a8,8,0,0,1,5.66,13.66L127.31,116l70.35,70.34A8,8,0,0,1,197.66,197.66Z" }, null, -1)
      ]))) : l(a) === "light" ? (o(), e("g", h, t[3] || (t[3] = [
        n("path", { d: "M196.24,196.24a6,6,0,0,1-8.48,0L70,78.48V168a6,6,0,0,1-12,0V64a6,6,0,0,1,6-6H168a6,6,0,0,1,0,12H78.48L196.24,187.76A6,6,0,0,1,196.24,196.24Z" }, null, -1)
      ]))) : l(a) === "regular" ? (o(), e("g", A, t[4] || (t[4] = [
        n("path", { d: "M197.66,197.66a8,8,0,0,1-11.32,0L72,83.31V168a8,8,0,0,1-16,0V64a8,8,0,0,1,8-8H168a8,8,0,0,1,0,16H83.31L197.66,186.34A8,8,0,0,1,197.66,197.66Z" }, null, -1)
      ]))) : l(a) === "thin" ? (o(), e("g", k, t[5] || (t[5] = [
        n("path", { d: "M194.83,194.83a4,4,0,0,1-5.66,0L68,73.66V168a4,4,0,0,1-8,0V64a4,4,0,0,1,4-4H168a4,4,0,0,1,0,8H73.66L194.83,189.17A4,4,0,0,1,194.83,194.83Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  y as default
};
